import moment from 'moment'
import * as Redux from 'redux'
import * as DragCell from '../../components/drag-cell'
import * as Form from '../../components/form'
import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Pager from '../../components/pager'
import * as Sortable from '../../components/sortable'
import * as Request from '../../request'
import * as PostsUtils from '../posts/utils'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'

const emptyViewState: Types.LeadPostsViewState = {
  filter: IsActive.FILTER_STATUS_ACTIVE,
  isDragged: false,
  isLoading: false,
  isSaving: false,
  sort: [],
}

const normalizeTypes: Sortable.TypeNormalizer<Types.LeadPost> =
  (payload: Sortable.SortableData<Types.LeadPost>): Sortable.SortableData<Types.LeadPost> => {
  return payload.map((lp: Types.LeadPost) => ({
    ...lp,
    category_type: lp.category_name,
    created_datetime: lp.created ? moment(lp.created) : null,
    end_datetime: lp.end_date ? moment(lp.end_date) : null,
    site_name: lp.name,
    start_datetime: lp.start_date ? moment(lp.start_date) : null,
    subscription_type_sortable: PostsUtils.subscriptionTypeToNum(lp.subscription_name),
    updated_datetime: lp.updated ? moment(lp.updated) : null,
  }))
}

const reducerEvent: Sortable.ReducerEvent<Types.LeadPost> = {
  defaultSort: {field: 'updated_datetime', dir: 'desc'},
  normalizer: normalizeTypes,
  requestEvent: Constants.FETCH_LEAD_POSTS,
}

const modalReducerEvent: Modal.ReducerEvent<{}> = {
  initializeState: () => Constants.emptyModalData,
  requestEvent: Constants.ADD_LEAD_POST,
  toggleEvent: Actions.FormConstants[Form.ENTER],
}

const keepModalOpen = (responseData: any) => responseData.title === '' || responseData.name === ''

const leadPostModalReducer = (sourceReducer: any) =>
  (state: Modal.State<Types.ModalData>, action: any ) => {
    const sourceState = sourceReducer(state, action)
    if (action.type === Request.successConstant(Constants.ADD_LEAD_POST)) {
        if (action.payload.response.retrieved_url) {
          return {
            ...sourceState,
            chooseUrl: true,
            isOpen: true,
            isSubmitting: false,
            original_url: action.payload.response.url,
            retrieved_url: action.payload.response.retrieved_url,
            submitSuccess: true,
          }
        } else if (keepModalOpen(action.payload.response)) {
          return {
            ...sourceState,
            data: {
              ...sourceState.data,
              showAddValidation: true,
            },
            isOpen: true,
            submitSuccess: false,
          }
        } else {
          return {
            ...sourceState,
            data: {
              ...sourceState.data,
              showAddValidation: false,
            },
            original_url: null,
            retrieved_url: null,
          }
        }
    } else if (action.type === Modal.closeModalConstant(Constants.ADD_LEAD_POST)) {
      return {
        ...sourceState,
        data: {
          ...sourceState.data,
          showAddValidation: false,
        },
        original_url: null,
        retrieved_url: null,
      }
    } else {
      return sourceState
    }
 }

const leadPostFormReducer = (sourceReducer: any) =>
 (state: Form.State<any>, action: any ) => {
   const sourceState = sourceReducer(state, action)
   if (action.type === Request.successConstant(Constants.ADD_LEAD_POST)) {
     return {
       ...sourceState,
       fields: {
        ...sourceState.fields,
        // TODO: column name should be abstracted
        description: action.payload.response.description,
        image_url: action.payload.response.image_url,
        rank: action.payload.response.rank,
        site_name: action.payload.response.name,
        title: action.payload.response.title,
        url: action.payload.response.url,
      },
     }
   } else {
     return sourceState
   }
}

const reorderReducer = (state: Types.LeadPostsViewState, action: any) => {
  switch (action.type) {
    case Request.requestConstant(Constants.SAVE_REORDERED_LEAD_POST):
      return {
        ...state,
        isSaving: true,
      }
    case Request.successConstant(Constants.SAVE_REORDERED_LEAD_POST):
    case Request.errorConstant(Constants.SAVE_REORDERED_LEAD_POST):
      return {
        ...state,
        isDragged: false,
        isSaving: false,
      }
    default:
      return state
  }
}

export const reducer = Redux.combineReducers({
  data: Request.reducerChain([
    IsActive.chainedReducer(Sortable.stateReducer(reducerEvent), Constants.UPDATE_LEAD_POST),
    DragCell.createDragReducer(Constants.FETCH_LEAD_POSTS),
  ]),
  form: leadPostFormReducer(Form.createReducer(Constants.FEATURED_POST_FORM)),
  modal: leadPostModalReducer(Modal.reducer(modalReducerEvent)),
  page: Pager.createReducer(Constants.FETCH_LEAD_POSTS),
  view: Request.reducerChain([
    IsActive.filterReducer(Sortable.viewReducer(reducerEvent), Constants.FETCH_LEAD_POSTS, emptyViewState),
    DragCell.createViewReducer(Constants.FETCH_LEAD_POSTS),
    reorderReducer,
  ]),
})



// WEBPACK FOOTER //
// ./src/pages/lead-posts/reducer.tsx